import { apiClient } from '../client'
import type {
  PurchaseOrder,
  CreatePurchaseOrderRequest,
  ShipRequest,
  ReceiveRequest,
  PurchaseOrderPageParams,
  PurchaseOrderPageResponse,
} from '../types/procurement'

export async function getPurchaseOrders(): Promise<PurchaseOrder[]> {
  const result = await getPurchaseOrderPage({ page: 0, size: 200 })
  return result.content
}

export async function getPurchaseOrderPage(
  params: PurchaseOrderPageParams = {}
): Promise<PurchaseOrderPageResponse> {
  const search = new URLSearchParams()
  search.set('page', String(params.page ?? 0))
  search.set('size', String(params.size ?? 20))
  if (params.status) search.set('status', params.status)
  if (params.keyword) search.set('keyword', params.keyword)
  return apiClient.get<PurchaseOrderPageResponse>(`/api/purchase-orders?${search.toString()}`)
}

export async function getPurchaseOrder(id: number): Promise<PurchaseOrder> {
  return apiClient.get<PurchaseOrder>(`/api/purchase-orders/${id}`)
}

export async function createPurchaseOrder(
  data: CreatePurchaseOrderRequest
): Promise<PurchaseOrder> {
  return apiClient.post<PurchaseOrder>('/api/purchase-orders', data)
}

export async function approvePurchaseOrder(id: number): Promise<PurchaseOrder> {
  return apiClient.post<PurchaseOrder>(`/api/purchase-orders/${id}/approve`, {})
}

export async function placePurchaseOrder(id: number): Promise<PurchaseOrder> {
  return apiClient.post<PurchaseOrder>(`/api/purchase-orders/${id}/order`, {})
}

export async function shipPurchaseOrder(
  id: number,
  data: ShipRequest
): Promise<PurchaseOrder> {
  return apiClient.post<PurchaseOrder>(`/api/purchase-orders/${id}/ship`, data)
}

export async function receivePartialPurchaseOrder(
  id: number,
  data: ReceiveRequest
): Promise<PurchaseOrder> {
  return apiClient.post<PurchaseOrder>(`/api/purchase-orders/${id}/receive-partial`, data)
}

export async function receiveAllPurchaseOrder(
  id: number,
  data: ReceiveRequest
): Promise<PurchaseOrder> {
  return apiClient.post<PurchaseOrder>(`/api/purchase-orders/${id}/receive-all`, data)
}
